<template>
  <div class="ui modal">
    <slot />
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'UiModal',
  props: {
    validated: {
      type: Boolean,
      default: true
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      $modal: null
    }
  },
  mounted () {
    const vm = this
    this.$modal = $(this.$el).modal({
      closable: this.closable,
      observeChanges: true,
      autofocus: false,
      duration: 0,
      onApprove () {
        vm.$emit('confirm', vm.$modal)
        if (vm.validated) vm.$emit('approve')
        return vm.validated
      },
      onHide () {
        $('body').removeClass('dimmable')
        return true
      },
      onHidden () {
        vm.$emit('hidden')
      }
    })

    this.$modal.modal('show')
  },
  beforeDestroy () {
    if (this.$modal) {
      this.$modal.remove()
    }
  }
}
</script>
